'use client';

import { CinemarkLink } from '@/components/cinemark-link/cinemark-link';
import { AnalyticsPageCategories } from '@/enums/analytics-type';
import clsx from 'clsx';
import Image from 'next/image';
import React from 'react';
import { AppDownloadLinks } from './app-download-links/app-download-links';
import { EmailUpdatesBar } from './email-bar/email-updates-bar';
import footerStyles from './footer.module.scss';
import { FooterLinks } from './links/footer-links';
import { SocialShareLinks } from './links/social-share-links';

export const Footer = (): React.JSX.Element => {
  return <>
    <EmailUpdatesBar />

    <footer className={footerStyles.footer}>
      <div className={clsx('container-xl', footerStyles['footer-content'])}>
        <div className={footerStyles['footer-links-content']}>
          <AppDownloadLinks />
          <div className={footerStyles['footer-logo-social']}>
            <CinemarkLink useAnchor
              aria-label="Cinemark Home"
              dataLinkCategory={AnalyticsPageCategories.FOOTER}
              dataLinkName="Home"
              dataTest="logo-link"
              href="/"
            >
              <Image alt="Cinemark logo"
                className={footerStyles['footer-logo']}
                height={42}
                src="/img/cinemarkLogo.png"
                width={301}
              />
            </CinemarkLink>
            <SocialShareLinks />
          </div>
          <FooterLinks />
        </div>
        <p className="text-xs"
          data-test="footer-copyright"
        >
          &copy;2025 Cinemark USA, Inc. Century Theatres, Cin&eacute;Arts, Rave,
          Tinseltown, and XD are Cinemark brands. &ldquo;Cinemark&rdquo; is a
          registered service mark of Cinemark USA, Inc.
        </p>
      </div>
    </footer>
  </>;
};
